export const laterality = [
  'L',
  'R'
];

export default laterality;
